import React from 'react';

import DeleteModal from 'components/modal/DeleteModal';
import { I18n } from 'components/translate';
import {
  EVENT_ACTIONS,
  EVENTS_INTERACTIONS,
  EVENTS_CATEGORY,
  EVENTS_LABELS
} from 'modules/app/services/datahub/constants';
import DatahubService from 'modules/app/services/datahub/DatahubService';
import { buildInteractionEventData } from 'modules/app/services/datahub/helper';
import ClassService from 'modules/classManager/ClassService';
import PropTypes from 'prop-types';

const sendEvent = (category, classId) => {
  DatahubService.sendEvent({
    action: EVENT_ACTIONS.INTERACT,
    event: buildInteractionEventData({
      category,
      action: EVENTS_INTERACTIONS.CLICK,
      label: `${EVENTS_LABELS.CLASS.CLASS_ID}=${classId}`
    })
  });
};

const ClassDeleteModal = ({ classId, onClose }) => {
  const handleCancel = () => {
    sendEvent(EVENTS_CATEGORY.CLASS.CANCEL_DELETE_CLASS, classId);
    onClose?.();
  };

  const handleConfirm = async () => {
    if (classId) {
      await ClassService.delete(classId);
      ClassService.fetchFormattedClasses();

      sendEvent(EVENTS_CATEGORY.CLASS.CONFIRM_DELETE_CLASS, classId);
    }
  };

  return (
    <DeleteModal
      isOpen
      title={<I18n label="class_manager.class_list.delete_content_title" />}
      description={<I18n label="general.delete_content_module_description" />}
      confirmLabel="general.delete_content_module_confirm"
      onCancel={handleCancel}
      onConfirm={handleConfirm}
    />
  );
};

ClassDeleteModal.propTypes = {
  classId: PropTypes.string.isRequired,
  onClose: PropTypes.func
};

export default ClassDeleteModal;
